<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-log-list" class="ag-grid-container">

    <div class="vx-card">
      <grid-action-bar
          :show-deleted="false"
          v-on:update:search="searchQuery = $event"
          title="Auth0 Logs"
      />

      <!-- AgGrid Table -->
      <t-grid
          :column-defs="columnDefs"
          class="xl"
          auto-size
          :data="data"
          :loading="loading"
          :search="searchQuery"
          @rowClicked="onRowClicked"
      >
      </t-grid>

    </div>
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import GridActionBar from "@/views/components/extra-components/GridActionBar";
import router from '../../../router';

export default {
  components: {
    TGrid,
    GridActionBar,
  },
  mixins: [CanAccessMixin],
  data () {
    return {
      searchQuery: '',
      showDeleted: false,

      // AgGrid
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 310,
          maxWidth: 350,
          filter: 'agTextColumnFilter',
          sortable: true,
          sort: 'desc',
        },
        {
          headerName: 'Message',
          field: 'Message',
          filter: 'agTextColumnFilter',
          width: 300,
        },
        {
          headerName: 'Type',
          field: 'Level_Name',
          width: 300,
        },
        {
          headerName: 'Date',
          field: 'Datetime',
          width: 300,
          filter: 'agTextColumnFilter',
        },

      ],
      // Cell Renderer Components
      data: [],
      loading: false,
    }
  },
  mounted() {
    this.list({ Level_Name: ['WARNING', 'ERROR', 'INFO'] });
  },
  methods: {
    async onRowClicked({data}) {
      const route = 'log.view';

      if (await this.canAccessRoute(route, false)) {
        router.push({ name: route, params: { id: data.id }}).catch(() => {});
      }
    },
    updateSearchQuery (val) {
      this.searchQuery = val;
    },
    async list(params = {}) {
      try {
        this.loading = true;
        const { data } = await this.$api.logs.all({ params });
        this.data = data.data;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
}

</script>

<style lang="scss">
</style>
